import { lang } from '@public/utils/filters'
export default {
  // 接待状态
  receiveState: [
    { value: 0, label: lang('退出'), name: lang('退出') },
    { value: 1, label: lang('在线'), name: lang('在线') },
    { value: 2, label: lang('忙碌'), name: lang('忙碌') },
    { value: 3, label: lang('离开'), name: lang('离开') }
  ],
}